import { actionTypes } from 'redux-form'
import { LOAD } from '../common/storage'
import delve from 'dlv'

export default (state = {}, { type, ...action }) => {
  switch (type) {
    // custom action to change field meta
    case `${actionTypes.prefix}META`:
      return {
        ...state,
        fields: {
          ...state.fields,
          [action.meta.field]: {
            ...state.fields[action.meta.field],
            ...action.payload
          }
        }
      }
    // storage action for loading from localStorage
    case LOAD: {
      const values = delve(action, 'payload.form.buyflow.values', {})
      return {
        ...state,
        values: {
          ...state.values,
          ...values
        }
      }
    }
    // redux-form actions that should reset the failed submission flag
    case actionTypes.CHANGE:
    case actionTypes.START_SUBMIT:
      if (action.meta && action.meta.form === 'buyflow') {
        return {
          ...state,
          submitFailed: false,
          confirmation: {}
        }
      }
      return state
    // custom action to show a generic confirmation message
    case 'confirmation/SHOW':
      return {
        ...state,
        confirmation: action
      }
    default:
      return state
  }
}
